import React from 'react'
import Modal from '../Modal/Modal'
import './Backdrop.css'

const Backdrop = () => {
  return (
    <div className='backdrop'>
        <Modal />
    </div>
  )
}

export default Backdrop
